// src/components/common/SkeletonLoader.tsx
import React from 'react';
import './SkeletonLoader.scss';

interface SkeletonLoaderProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Skeleton Loader Component with shimmer animation
 * Used to show loading placeholders while data is being fetched
 */
const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  width = '100%',
  height = 20,
  borderRadius = 4,
  className = '',
  style,
}) => {
  return (
    <div
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
        borderRadius,
        ...style,
      }}
    />
  );
};

export default SkeletonLoader;

